import { Component, Input } from "@angular/core";
import { Condicion } from "../clases/Condicion";
import { TipoCondicionEnum } from "@shared/enums";
import { EncuestaDTO } from "@DTOS";
import { Nilable } from "@shared/utils";
import { ItemPreguntaModelDTO, PreguntaModelDTO } from "@Models";

@Component({
    selector: "app-condicion",
    templateUrl: "./condicion.component.html",
    styleUrls: ["./condicion.component.scss"]
})
export class CondicionComponent {
    @Input() public condicion: Nilable<Condicion>;
    @Input() public encuesta: Nilable<EncuestaDTO>;
    @Input() public pregunta: PreguntaModelDTO;
    @Input() public item: ItemPreguntaModelDTO;

    public TipoCondicionEnum = TipoCondicionEnum;

    constructor() { }

}
